/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ChangeOrderLocationCommandFromJSON(json) {
    return ChangeOrderLocationCommandFromJSONTyped(json, false);
}
export function ChangeOrderLocationCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'newLocation1': !exists(json, 'newLocation1') ? undefined : json['newLocation1'],
        'newLocation2': !exists(json, 'newLocation2') ? undefined : json['newLocation2'],
        'newLocation3': !exists(json, 'newLocation3') ? undefined : json['newLocation3'],
        'newFloor': !exists(json, 'newFloor') ? undefined : json['newFloor'],
    };
}
export function ChangeOrderLocationCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'newLocation1': value.newLocation1,
        'newLocation2': value.newLocation2,
        'newLocation3': value.newLocation3,
        'newFloor': value.newFloor,
    };
}
